<template>
    <v-select 
       :value="selected_reporter" 
       v-bind:items="reporters"
       item-value="code" 
       item-text="description" 
       :label="label"
       dense :clearable="isClearable"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_reporter: String,
        label: {
            type: String,
            default: 'Reported by'
        },    
        field: {
            default: 'reporter',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
    },  
    data() {
        return {
            reporters: 
                [
                    {code: 'customer', description: 'Guest'},
                    {code: 'owner', description: 'Owner'},
                    {code: 'caretaker', description: 'Caretaker'},
                    {code: 'partner', description: 'Partner'},
                    {code: 'rentalexpert', description: 'Rental expert'},
                    {code: 'other', description: 'Other'}
                ],
        }
    },
    methods: {
        updateData(v){
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
        }
    }
}

</script>